import type { Viewer } from '../viewer/Viewer';
/** The single Viewer instance (set by App once WebGL is up). */
export const viewerRef: { current: Viewer | null } = { current: null };
